module.exports = __webpack_public_path__ + "static/media/sf_1600_gray.81af537bbc79baf73ae1d5f3382081c5.png";